import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { SyncDataEffects } from './sync-data.effects';
import { ISyncDataFeature } from './sync-data.feature.state';
import { syncDataReducer } from './sync-data.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ISyncDataFeature>('syncDataFeature'), syncDataReducer),
    EffectsModule.forFeature([SyncDataEffects]),
  ],
})
export class SyncDataStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: SyncDataStateModule
  ) {
    if (parentModule) {
      throw new Error('SyncDataStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
